export enum CDCEventType {
  CREATE = 'CREATE',
  MODIFY = 'MODIFY',
  DELETE = 'DELETE',
}

export interface CDCEvent<T> {
  before: T | null;
  after: T | null;
  receiveTimestamp: number;
  timestamp: number;
  eventType: CDCEventType;
  source: {
    connector: string;
    name: string;
    db: string;
    schema: string;
    table: string;
  };
}

export interface CDCCreateEvent<T> extends CDCEvent<T> {
  before: null;
  after: T;
}

export interface CDCModifyEvent<T> extends CDCEvent<T> {
  before: T;
  after: T;
}

export interface CDCDeleteEvent<T> extends CDCEvent<T> {
  before: T;
  after: null;
}
